import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ComplaintService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  createComplaint(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/complaints', payload);
  }

  listComplaints(status?: string): Observable<any> {
    let url = this.apiUrl + '/complaints';
    if (status) url += '?status=' + encodeURIComponent(status);
    return this.http.get<any>(url);
  }

  updateComplaint(id: number, payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/complaints/' + id, payload);
  }
}
